import { defineComponent as t, openBlock as a, createBlock as r, unref as n, mergeProps as c, withCtx as p, createElementVNode as d } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconHeartExploded",
  __name: "IconHeartExploded",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(l) {
    const o = l;
    return (i, e) => (a(), r(n(m), c(o, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        d("path", {
          "fill-rule": "evenodd",
          d: "M7.5 5.608a3.75 3.75 0 0 0-3.75 3.75c0 1.139.596 2.126 1.462 2.977l.014.014 5.186 5.664 1.045-4.314-1.907.477a1.25 1.25 0 0 1-1.486-1.616v-.002l2.046-5.942C9.37 6.07 8.452 5.608 7.5 5.608m3.479 13.25.72.209a1.143 1.143 0 0 1-1.94.453l-5.613-6.13C3.138 12.397 2.25 11.052 2.25 9.359c0-2.9 2.35-5.25 5.25-5.25 1.511 0 2.818.766 3.687 1.442a1.23 1.23 0 0 1 .403 1.376L9.633 12.61l1.861-.465a1.25 1.25 0 0 1 1.518 1.507l-1.305 5.384-.728-.177m3.248-14.107c.641-.37 1.34-.643 2.273-.643 2.9 0 5.25 2.35 5.25 5.25 0 1.698-.893 3.045-1.904 4.04L15.7 17.677c-.616.635-1.677.056-1.476-.806l.01-.044L15.97 9.89l-1.903.476a1.25 1.25 0 0 1-1.49-1.607V8.757l1.099-3.324a1.23 1.23 0 0 1 .552-.682m.84 1.247L14.143 8.8l1.868-.467a1.25 1.25 0 0 1 1.515 1.516l-1.276 5.107 2.533-2.614.006-.006c.866-.851 1.462-1.838 1.462-2.977a3.75 3.75 0 0 0-3.75-3.75c-.56 0-.983.143-1.432.39",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
